// extracted by mini-css-extract-plugin
export default {"container":"uY-z","title":"vY-z","link":"wY-z"};